module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Plymouth-f525440750e7b738c6f0d09867058f29.svg";